import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Bell, Check, X } from 'lucide-react';
import { format } from 'date-fns';
import { PRIORITY_OPTIONS } from './constants';

export const ReminderCard = ({ reminder, onComplete, onDismiss, isOverdue }) => {
  const priorityConfig = PRIORITY_OPTIONS.find(p => p.value === reminder.priority) || PRIORITY_OPTIONS[1];
  
  return (
    <Card className={isOverdue ? 'border-red-200 bg-red-50/50' : ''} data-testid={`reminder-card-${reminder.id}`}>
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className={`h-10 w-10 rounded-full flex items-center justify-center ${isOverdue ? 'bg-red-100' : 'bg-amber-100'}`}>
              <Bell className={`h-5 w-5 ${isOverdue ? 'text-red-600' : 'text-amber-600'}`} />
            </div>
            <div>
              <h4 className="font-medium">{reminder.title}</h4>
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <span>{reminder.lead?.name}</span>
                <Badge className={priorityConfig.color}>{priorityConfig.label}</Badge>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm text-muted-foreground">
              {format(new Date(reminder.due_date), 'dd MMM, hh:mm a')}
            </span>
            <Button variant="ghost" size="icon" onClick={() => onComplete(reminder.id)} data-testid={`complete-reminder-${reminder.id}`}>
              <Check className="h-4 w-4 text-emerald-600" />
            </Button>
            <Button variant="ghost" size="icon" onClick={() => onDismiss(reminder.id)} data-testid={`dismiss-reminder-${reminder.id}`}>
              <X className="h-4 w-4 text-muted-foreground" />
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
